import {QueryEntry} from 'common/widgets/query-event-selector/types';
import FullLengthDateRange from 'common/widgets/date-range-picker/models/full-length-date-range';
import PropertyFilter from 'common/widgets/property-filter-menu/models/property-filter';
import {SavedCohortSegment} from 'common/widgets/query-block/segment-menu/types';
import {Expression} from 'common/widgets/property-filter-menu/models/selector-tree/types';

export enum ChartType {
  Sankey = `sankey`,
  Paths = `paths`,
}

export const ChartTypeLabels = {
  [ChartType.Sankey]: `Paths`,
  [ChartType.Paths]: `Top paths`,
};

export const ChartTypeIcon: {[key in ChartType]: string} = {
  [ChartType.Paths]: `funnel-steps`,
  [ChartType.Sankey]: `top-paths`,
};

export enum MergeType {
  Graph = `graph`,
  List = `list`,
}

export enum FlowDirection {
  Forward = `forward`,
  Reverse = `reverse`,
}

export const CHART_TYPE_TO_QUERY_PARAM = {
  [ChartType.Sankey]: MergeType.Graph,
  [ChartType.Paths]: MergeType.List,
};

export interface AnchorsFlowsReport {
  anchors: Array<{
    event: QueryEntry;
    forward?: number;
    reverse?: number;
  }>;
  dateRange: FullLengthDateRange;
  filterByCohort: SavedCohortSegment['cohort'];
  filters: PropertyFilter[];
  groupByCohorts: Array<SavedCohortSegment['cohort']>;
}

export interface AnchorsFlowsReportQueryParams {
  anchors: Array<{
    event: QueryEntry;
    forward?: number;
    reverse?: number;
  }>;
  filter_by_cohort: {} | SavedCohortSegment['cohort'];
  filter: Expression;
  from_date?: string;
  group_by_cohorts: Array<SavedCohortSegment['cohort']>;
  to_date?: string;
  time_percentiles: number[];
}

export const AnchorsFlowsReportDefaults = {
  anchors: [],
  dateRange: new FullLengthDateRange(),
  filters: [],
  filterByCohort: null,
  groupByCohorts: [],
};
